.textAreaContainer {
  margin-bottom: 1em;
  position: relative;
}

.textAreaContainer label {
  font-size: 1rem;
  color: var(--black);
  font-weight: unset;
}

.textArea {
  width: 100%;
  min-height: 11.5em;
  padding: 0.5em;
  font-size: 1em;
  border: 2px solid var(--black);
  resize: none;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
